import BybAvatar from "@Components/common/byb-ds/byb-avatar";
import { HoverScaleBackground, hoverScaleProps } from "@Components/common/hover-scale-button";
import { Typography } from "@mui/material";
import { CardContainer, CardContent } from "./styled-components";

interface ProfileCardProps {
  name: string;
  avatarUrl?: string;
  league?: string;
  onClick: () => void;
}

const ProfileCard = ({ name, avatarUrl, league, onClick }: ProfileCardProps) => {
  return (
    <CardContainer onClick={onClick}>
      <HoverScaleBackground
        {...hoverScaleProps}
        sx={(theme) => ({
          borderRadius: theme.spacing(2.5),
        })}
      />
      <CardContent spacing={3} alignItems="center">
        <BybAvatar src={avatarUrl} league={league} size={12} />
        <Typography variant="text2xl600" color="dsBase.v200">
          {name}
        </Typography>
      </CardContent>
    </CardContainer>
  );
};

export default ProfileCard;
